import * as React from 'react';
import { makeStyles } from '@mui/styles';
import { ICON_ARROW_UP, ICON_ARROW_DOWN } from '../_style';
import { Box, Toolbar, Collapse } from '@mui/material';


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',  // inherit 100%
    borderRadius: theme.borderRadius.large,
    overflow: 'hidden',
  },
  toolbar: {
    padding: 0,
  },
  title: {
    marginBottom: -1,
    minHeight: 50,
    backgroundColor: theme.palette.background.PaperTitle,
    '& .title': {
      paddingLeft: 20,
      display: 'flex',
      alignItems: 'center',
      fontWeight: 700,
    },
  },
  content: {
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    // zIndex: 10,
  },
}));


/**
 * 頁面 paper
 * @param {object} content 內容
 * @param {boolean} contentPadding 內距：預設20 無內距：false
 * @param {string} title 標題
 * @param {array} collapse 
 * 　collapse[0] 折疊：是否使用折疊功能 是 true 否 false
 * 　collapse[1] 折疊：預設開 true 或 關 false
 * @param {boolean} shadow 陰影
 */
export function PagePaper({content, contentPadding, title, toolbar, collapse, shadow}) {

  const classes = useStyles();
  const [open, setOpen] = React.useState(collapse ? collapse[1] : true);

  const openClick = (status) => {
    setOpen(status);
  }
  
  return (
    <Box
      className={classes.root}
      sx={{
        boxShadow: (theme) => shadow ? theme.palette.shadow.main : null,
      }}
    >

      {
        title
        ?      
          <Box className={classes.title}>
            <Toolbar className={classes.toolbar}>

              <Box flexGrow={1} className='title'>{title}</Box>

              { toolbar ? toolbar : null }

              {
                collapse && collapse[0]
                ?
                  <Box>
                    {
                      open
                      ? <ICON_ARROW_UP classes={classes.iconArrow} mode='btn' onClick={() => openClick(false)} />
                      : <ICON_ARROW_DOWN classes={classes.iconArrow} mode='btn' onClick={() => openClick(true)} />
                    }
                  </Box>
                : null
              }

            </Toolbar>
          </Box>
        : null
      }

      <Collapse
        in={open}
        sx={{
          width: 'inherit',
        }}
      >
        <Box className={classes.content} p={contentPadding===false ? 0 : 4}>
          {content}
        </Box>
      </Collapse>

    </Box>
  )
}